const theme = {
  color1: "rgb(1, 42, 54);",
  color2: "rgb(234, 234, 234);",
  color3: "rgb(2, 82, 107);",
  color4: "rgb(2, 82, 107);",
  color5: "rgb(234, 234, 234)",
  color6: "rgb(196, 196, 196)",
  color7: "rgb(233, 235, 238)",
  helpColor: "rgb(137, 49, 104)",
  fontColor: "rgb(1, 42, 54)",
  menuColor: "rgb(137, 49, 104)",
  grayTextColor: "#7f7f7f",
  entityName: "project",
  name: "Random Research"
};

export default theme;
